import type { ReactNode } from "react";

export function Hover3dCard({ children, href }: { children: ReactNode; href?: string }) {
  const innerContent = (
    <>
      <figure className="m-4 mb-6 mt-0 max-w-125 min-w-105 aspect-video bg-base-200 rounded-2xl overflow-hidden">
        {children}
      </figure>
      {/* 8 empty divs needed for the 3D effect */}
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </>
  );

  if (href?.length) {
    return (
      <a href={href} className="hover-3d cursor-pointer">
        {innerContent}
      </a>
    );
  }

  return <div className="hover-3d">{innerContent}</div>;
}
